import { render, staticRenderFns } from "./AuthIndication.vue?vue&type=template&id=67f28e32&scoped=true&"
import script from "./AuthIndication.vue?vue&type=script&lang=js&"
export * from "./AuthIndication.vue?vue&type=script&lang=js&"
import style0 from "./AuthIndication.vue?vue&type=style&index=0&id=67f28e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f28e32",
  null
  
)

export default component.exports